import { z } from "zod";

export enum RequestParameterTypeEnum {
    /// Corresponds to html input type text
    SHORT_TEXT = 1,
    /// Corresponds to html textarea
    LONG_TEXT = 2,
    /// Corresponds to html input type number
    NUMBER = 3,
    /// Corresponds to html date input
    DATE = 4,
    /// Validated field for poistka id
    POISTKA_ID = 5,
    /// Validated field for skoda id
    SKODA_ID = 6,
    /// Validated field for partner id
    PARTNER_ID = 7,
    /// Validated field for checkbox
    CHECKBOX = 8,
    /// Validated field for radio button
    RADIO_BUTTON = 9,
    /// Field with partner's existing address
    ADDRESS_TEXT = 10,
    /// Field with contract's vehicle
    VEHICLE = 11,
    /// Field with optional email of client for notification sender & email autocorrection
    CLIENT_EMAIL = 12,
    /// Field with email correction
    EMAIL = 13,
    /// Field with required email of client for notificaition sender & email autocorrection
    CONTACT_EMAIL = 14,
    /// Euro money field - FE allows only digits and spaces; when the user types digits,
    /// FE automatically inserts a space after every 3rd digit (thousands grouping).
    MONEY = 15,
    /// Read-only display text. Rendering depends on the field's DisplayType:
    ///  - DisplayType 1 (Vertical info):   ParameterText = label, ParameterValue = value
    ///  - DisplayType 2 (Horizontal info): ParameterText = label, ParameterValue = value
    ///  - DisplayType 3 (Info block heading): uses ParameterValue (falls back to ParameterText if empty)
    DISPLAY_TEXT = 16,
    /// Notice box. Rendering depends on the field's DisplayType:
    ///  - DisplayType 1 (Info notice, blue box):    uses ParameterValue (falls back to ParameterText if empty)
    ///  - DisplayType 2 (Warning notice, orange/yellow box): uses ParameterValue (falls back to ParameterText if empty)
    ///    Not used in the new request yet - prepared for future use.
    NOTICE = 17,
    /// Field with phone number correction
    PHONE = 18
}

export const RequestParameterTypeEnumSchema = z.nativeEnum(RequestParameterTypeEnum);
